// directives/v-track-element.js
import { useElementTracker } from '../composables/useElementTracker';

const tracker = useElementTracker();

export default {
  mounted(el, binding) {
    // Get distortion name from data-scene attribute
    const sceneName = el.getAttribute('data-scene');
    tracker.addElement(el, sceneName);
  },
  unmounted(el) {
    tracker.removeElement(el);
  },
};

export { tracker }; // Export the tracker for reactive access elsewhere
